import { iconMap } from '../../../../../ui/Icons/IconMap';

export function stringToIcon(image: string) {
  switch (image.toLowerCase()) {
    case 'ally':
      return iconMap.allyIcon;
    case 'amex':
      return iconMap.amexIcon;
    case 'bankofamerica':
      return iconMap.bankOfAmericaIcon;
    case 'bankofthewest':
      return iconMap.bankOfTheWestIcon;
    case 'bbandT':
      return iconMap.bbAndTIcon;
    case 'capitalone':
      return iconMap.capitalOneIcon;
    case 'charlesschwab':
      return iconMap.charlesSchwabIcon;
    case 'chase':
      return iconMap.chaseIcon;
    case 'citibank':
      return iconMap.citiIcon;
    case 'citizenbank':
      return iconMap.citizensBankIcon;
    case 'dis':
    case 'discover':
      return iconMap.discoverIcon;
    case 'easypay':
      return iconMap.easyPayIcon;
    case 'fidelity':
      return iconMap.fidelityIcon;
    case 'fifththirdbank':
      return iconMap.fifthThirdIcon;
    case 'genericbank':
      return iconMap.genericBankIcon;
    case 'huntingtonnationalbank':
      return iconMap.huntingtonIcon;
    case 'mc':
    case 'mastercard':
      return iconMap.mastercardIcon;
    case 'navyfederal':
      return iconMap.navyFederalIcon;
    case 'noprovider':
      return iconMap.noProviderIcon;
    case 'paymentchips':
      return iconMap.paymentChipsIcon;
    case 'pnc':
      return iconMap.pncIcon;
    case 'regions':
      return iconMap.regionsIcon;
    case 'suntrust':
      return iconMap.sunTrustIcon;
    case 'tdameritrade':
      return iconMap.tdAmeritradeIcon;
    case 'usbank':
      return iconMap.usBankIcon;
    case 'usaa':
      return iconMap.usaaIcon;
    case 'visa':
      return iconMap.visaIcon;
    case 'wellsfargo':
      return iconMap.wellsFargoIcon;
    case 'genericcard':
    default:
      return iconMap.genericCardIcon;
  }
}

export function getCardSvg(image: string, altImage: string) {
  return (
    stringToIcon(image) ||
    stringToIcon(altImage) ||
    stringToIcon('genericcard')
  );
}
